<template>
    <div v-if="$store.state.isModalOpenTwo" class="modal fade show my-2" aria-labelledby="addNewCardTitle" style="display: block; background: #1c1d1c33">
        <div class="modal-dialog modal-md modal-dialog-centered" ref="modalRef">
            <div class="modal-content">
                <div class="row">
                    <div class="col-12">
                        <div class="d-flex justify-content-between px-1 my-1 align-item-center">
                          <h1 class="mb-0">Manual Attendance</h1>
                            <button
                                @click="onClickClose"
                                type="button"
                                class="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            ></button>
                        </div>
                    </div>
                </div>

                <hr class="mt-0 mb-0">

                <div class="pb-2">
                  <div class="row mx-2">

                    <div class="col-12">
                      <div class="mb-1">
                        <label class="form-label" for="mobileNo"> <span class="required">*</span> In Time </label>
                        <input
                            class="form-control invoice-edit-input date-picker flatpickr-input flatpickr-mobile"
                            tabindex="1"
                            type="datetime-local"
                            placeholder=""
                            v-model="formData.in_time"
                        >
                      </div>
                    </div>

                    <div class="col-12">
                      <div class="mb-1">
                        <label class="form-label" for="mobileNo">Out Time </label>
                        <input
                            class="form-control invoice-edit-input date-picker flatpickr-input flatpickr-mobile"
                            tabindex="1"
                            type="datetime-local"
                            placeholder=""
                            v-model="formData.out_time"
                        >
                      </div>
                    </div>

                    <div class="col-12">
                      <div class="mb-1">
                        <label class="form-label" for="mobileNo">Remarks </label>
                        <input
                            class="form-control invoice-edit-input date-picker flatpickr-input flatpickr-mobile"
                            tabindex="1"
                            type="text"
                            placeholder=""
                            v-model="formData.remarks"
                        >
                      </div>
                    </div>

                    <div class="col-6 text-center mb-2 mt-2">
                      <button :disabled="loading" @click="submit" type="button" class="btn btn-primary full-width me-1 waves-effect waves-float waves-light">
                        <div v-if="loading" class="spinner-border spinner-border-sm text-light" role="status">
                          <span class="visually-hidden">Loading...</span>
                        </div>
                        Submit
                      </button>
                    </div>
                    </div>
                 </div>
            </div>
        </div>
        <Loader v-if="loader"/>

    </div>
</template>

<script setup>
import Loader from "@/components/atom/LoaderComponent";
import { inject, ref, watch } from "vue";
import { useStore } from "vuex";
import { useRoute } from 'vue-router';
import useDate from '@/services/utils/day'
import handleHrPayroll from "@/services/modules/hrPayroll/hrPayroll";

const props = defineProps({
    formData:{
      type:Object,
      default:{}
    },
});

const emit = defineEmits(['getAttendanceList']);
const $store = useStore();
const $route = useRoute();
const modalRef = ref(null);
const loading = ref(false);
const isEdit = ref(false);
const loader = ref(false);
const showError = inject('showError');
const showSuccess = inject('showSuccess');
const { formatDateTime } = useDate()

const {
  fetchTypes,
  createManualAttendance,
  updateManualAttendance
} = handleHrPayroll()

const submit = async() => {
    const query = getQuery();
    loading.value = true;
    if (isEdit.value){
      await updateData(query)
      return
    }
    await storeData(query)
}

const storeData = async (query) => {
  let attendanceData = {};
  attendanceData.in_time = props.formData.in_time ? formatDateTime(props.formData.in_time) : null;
  attendanceData.out_time = props.formData.out_time ? formatDateTime(props.formData.out_time) : null;
  attendanceData.remarks = props.formData.remarks;
  attendanceData.status = 'pending';
  attendanceData.hr_manual = false;

  await createManualAttendance(attendanceData, query).then((res) => {
    loading.value = false
    if (!res.status) return showError(res.message)
    emit("getAttendanceList");
    onClickClose();
    showSuccess(res.message)
  }).catch(err => {
    console.log(err)
  }).finally(() => {
    loading.value = false
  })
}

const updateData = async (query) => {
  let attendanceData = {};
  attendanceData.in_time = props.formData.in_time ? formatDateTime(props.formData.in_time) : null;
  attendanceData.out_time = props.formData.out_time ? formatDateTime(props.formData.out_time) : null;
  attendanceData.remarks = props.formData.remarks;
  attendanceData.id = props.formData.id;
  attendanceData.status = 'pending';
  attendanceData.hr_manual = false;
  await updateManualAttendance(attendanceData, attendanceData.id, query).then((res) => {
    loading.value = false
    if (!res.status) return showError(res.message)
    emit("getAttendanceList");
    onClickClose();
    showSuccess(res.message)
  }).catch(err => {
    console.log(err)
  }).finally(() => {
    loading.value = false
  })
}

const onClickClose = () => {
    $store.state.isModalOpenTwo = false;
}

function getQuery() {
  return `?company_id=${$route.params.companyId}`;
}

watch(() => props.formData, (newVal) => {
  if (newVal.is_edit){
    isEdit.value = true;
  }
}, { immediate: true, deep: true })


</script>
